import { Component, OnInit } from "@angular/core";
import { PollsService } from "./polls.service";
import { ResponseTranslation } from "../shared/translation.service";

@Component({
  selector: "create-poll",
  template: require('./createpoll.component.html'),
  styles: [require('./createpoll.component.scss')]
})
export class CreatePollComponent implements OnInit {
  poll: any = {
    active: false,
    context: {
      project_ids: [],
      nationalities: [],
      employer_ids: [],
      countries: []
    },
    content: {}
  };
  translations: any[] = [];
  languages: any[] = this.getLanguages();
  clicked: boolean = false;
  responseValues: any[] = [];
  activePanels: string[] = ["status", "visibility"];

  constructor(private service: PollsService) {}

  ngOnInit() {
    this.addTranslation();
    this.translations[0].language = "en";
  }

  getLanguages(): any[] {
    return this.service.getLanguages();
  }

  getPanelTitle(translation: ResponseTranslation, first: boolean) {
    let text;
    let selectedLang = this.languages.filter((language: any) => {
      return language.key === translation.language;
    })[0];
    text =
      selectedLang && selectedLang.value
        ? selectedLang.value
        : "Choose a language";
    if (first) {
      text += " (Default)";
    }
    return text;
  }

  addTranslation() {
    let t;
    t = new ResponseTranslation();
    if (this.responseValues) {
      this.responseValues.map((r) => {
        t.responseTexts.push("");
      });
    }
    this.translations.push(t);
    this.activePanels.push("translations" + (this.translations.length - 1));
  }

  deleteTranslation(item: any) {
    let index = this.translations.indexOf(item);
    if (index > -1) {
      this.translations.splice(index, 1);
      this.activePanels.splice(this.activePanels.length - 1, 1);
    }
  }

  addResponse() {
    this.translations.map((it) => {
      it.responseTexts.push("");
    });
    this.responseValues.push({ value: "" });
  }

  setDefault(index: number) {
    let t = this.translations[0];
    this.translations[0] = this.translations[index];
    this.translations[index] = t;
  }

  move(from: number, to: number) {
    let backup = this.responseValues[from];
    this.responseValues[from] = this.responseValues[to];
    this.responseValues[to] = backup;
    this.translations.map((translation) => {
      let back = translation.responseTexts[from];
      translation.responseTexts[from] = translation.responseTexts[to];
      translation.responseTexts[to] = back;
    });
  }

  delete(index: number) {
    if (window.confirm("Are you sure?")) {
      this.responseValues.splice(index, 1);
      this.translations.map((translation) => {
        translation.responseTexts.splice(index, 1);
      });
    }
  }

  onSubmit() {
    this.activePanels = [];
    setTimeout(() => {
      this.save();
    }, 1);
  }

  save() {
    if (!this.clicked) {
      this.clicked = true;
      let defLang;
      this.translations.map((it: any) => {
        if (it.language !== "") {
          if (!defLang) {
            defLang = it.language;
          }
          this.poll.content[it.language] = {
            title: it.title,
            question: it.question,
            description: it.description,
            responses: []
          };
          let index = 0;
          this.responseValues.map((v) => {
            this.poll.content[it.language].responses.push({
              value: v.value,
              text: it.responseTexts[index]
            });
            index++;
          });
        }
      });
      this.poll.default_lang = defLang;
      this.service.createPoll(this.poll).subscribe(
        (response) => {
          this.clicked = false;
          this.back();
        },
        (error) => {
          this.activePanels = ["status", "visibility"];
          this.translations.map((it, index) => {
            this.activePanels.push("translations" + index);
          });
          this.clicked = false;
        }
      );
    }
  }

  back() {
    window.history.back();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/polls/createpoll.component.ts